import React, { useState, useRef, useEffect } from "react";
import {
    useParams,
    useLocation
} from "react-router-dom";
import { ArticleNotFound } from "./article-not-found";
import { TrackEvent } from "./utils";
import { Helmet } from "react-helmet-async";


export function Article(props) {    
    let { pathname } = useLocation();    

    let { categoryId, articleId } = useParams();    

    // if Article component not called via Route (for mobile), then articleId via useParams unavail
    if (props.isMobile) {
        articleId = props.articleId;
        categoryId = props.categoryId;
    }

    let article = props.data.articles.find((item) => item.categorySlug === categoryId && item.slug === articleId);

    if (!article) {
        return <ArticleNotFound data={props.data.articlesNotFound} />
    }

    const articleRef = useRef(null);
    const [animateState, setAnimateState] = useState('');

    const articleContentRef = useRef(null);

    const contactUsPanel = useRef(null);
    const contactUsTrigger = useRef(null);

    const findIFAPanel = useRef(null);
    const findIFATrigger = useRef(null);


    const $rootEl = document.querySelector('#root');


    function handleContentLinkClick(e) {
        TrackEvent('link', { 'context': e.currentTarget.textContent });
    }


    // animate and scroll into view on article load
    useEffect(() => {

        // hide panels on article render
        $(contactUsPanel.current)
            .collapse({ toggle: false })
            .collapse('hide');
        $(contactUsTrigger.current).addClass('collapsed');

        $(findIFAPanel.current)
            .collapse({ toggle: false })
            .collapse('hide');
        $(findIFATrigger.current).addClass('collapsed');



        // don't minimize by default (for mobile)
        props.setHelpItemMinimized(false);

        // animate article in
        setAnimateState('animating-in');
        const timeoutId = setTimeout(() => {
            articleRef.current?.scrollIntoView({ behavior: 'smooth', block: "start" });
            setAnimateState('animating-out');
        }, 220);

        // init any tooltips if exist
        AG.ui.tooltips.init();


        // tracking for injected links (should be automatically tracked by GTM instead)
        // let contentLinks = articleContentRef.current.querySelectorAll(".help-centre-item__copy a");
        // if (contentLinks && contentLinks.length) {
        //   for (let i = 0; i < contentLinks.length; i++) {
        //     contentLinks[i].addEventListener("click", handleContentLinkClick);
        //   }
        // }


        return () => {
            clearTimeout(timeoutId);
        }

    }, [articleId]);




    return (
        <div className={`help-centre-item ${animateState} ${props.helpItemMinimized ? "is-minimized" : ""}`} ref={articleRef}

        >
            <Helmet>
                <title>{props.data.pageTitlePrefix + props.data.welcomeContent.pageTitle + ' | ' + (article.longTitle ? article.longTitle : article.title)}</title>

                <meta name="description" content={article.description ? article.description : article.longTitle} />
                <link rel="canonical" href={window.location.origin + $rootEl.getAttribute('data-basename') + pathname} />
                <meta property="og:url" content={window.location.origin + $rootEl.getAttribute('data-basename') + pathname} />
                <meta property="og:title" content={props.data.pageTitlePrefix + props.data.welcomeContent.pageTitle + ' | ' + (article.longTitle ? article.longTitle : article.title)} />

            </Helmet>
            <div className="help-centre-item__copy" ref={articleContentRef}>
                <h2>{article.longTitle ? article.longTitle : article.title}
                </h2>
                <div
                    dangerouslySetInnerHTML={{
                        __html: article.content
                    }}
                ></div>
            </div>
            <hr />
            <div className="help-centre-item__more">
                <p>{props.data.moreHelp.title}</p>

                <div className="help-centre-item__panels">

                    <div className="panel">

                        <a href={`#contact-us-panel${props.isMobile ? '-mobile' : ''}`} data-toggle="collapse"
                            className="button button--block button--secondary-blue collapsed"
                            ref={contactUsTrigger}
                            onClick={() => TrackEvent('accordion', { 'title': props.data.moreHelp.contactUs.buttonText })}
                        >
                            <i className="agi agi--left agi-phone"></i>
                            <span className="button__text">
                                {props.data.moreHelp.contactUs.buttonText}
                            </span>
                            <i className="agi agi-f-chevron-right"></i>
                        </a>

                        <div className="contact-us-panel collapse" id={`contact-us-panel${props.isMobile ? '-mobile' : ''}`} ref={contactUsPanel}>
                            <div className="panel-body grey-background">

                                <ul className="help-centre-contact">

                                    {props.data.moreHelp.contactUs.listItems.map((item, i) => (
                                        <li key={i}>
                                            <div className="help-centre-contact__icon">
                                                <i className={`agi ${item.iconRef}`}></i>
                                            </div>
                                            <div className="help-centre-contact__text">
                                                <strong>{item.title}</strong>
                                                <a href={`tel:${item.phone}`}>{item.phoneFormatted}</a>
                                            </div>
                                        </li>
                                    ))}
                                </ul>

                            </div>

                        </div>

                    </div>

                    {article.ifaButton &&

                        <div className="panel">

                            <a href={`#find-ifa-panel${props.isMobile ? '-mobile' : ''}`} data-toggle="collapse"
                                className="button button--block button--secondary-grey collapsed"
                                ref={findIFATrigger}
                                onClick={() => TrackEvent('accordion', { 'title': props.data.moreHelp.findIFA.buttonText })}
                            >
                                <i className="agi agi--left agi-briefcase"></i>
                                <span className="button__text">
                                    {props.data.moreHelp.findIFA.buttonText}
                                </span>
                                <i className="agi agi-f-chevron-right"></i>
                            </a>

                            <div className="find-ifa-panel collapse" id={`find-ifa-panel${props.isMobile ? '-mobile' : ''}`} ref={findIFAPanel}>
                                <div className="panel-body grey-background">
                                    <p>{props.data.moreHelp.findIFA.content}</p>
                                    <p>
                                        <a href={`${props.data.moreHelp.findIFA.link}`}
                                            onClick={() => TrackEvent('link', { 'context': props.data.moreHelp.findIFA.linkText })}>
                                            {props.data.moreHelp.findIFA.linkText}
                                        </a>
                                    </p>
                                </div>

                            </div>

                        </div>

                    }


                </div>


            </div>
            <span className="help-centre__minimize" onClick={() => props.setHelpItemMinimized(!props.helpItemMinimized)}>
                <span className="icon"></span>
            </span>
            {/* <Link to="/" className="help-centre__close">
          <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.58 12 5 17.58 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
        </Link> */}
        </div>
    );
}